import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	uploadConfiguration: {
		id: 'project-create-importer-upload-flow.upload-screen-standard.upload-config.upload-configuration',
		defaultMessage: 'Upload File',
		description: 'Upload configuration file',
	},
	uploadConfigurationAccordionHeading: {
		id: 'project-create-importer-upload-flow.upload-screen-standard.upload-config.upload-configuration-accordion-heading',
		defaultMessage: 'Upload a configuration file (optional)',
		description: 'Upload configuration accordion heading',
	},
	uploadConfigurationDescription: {
		id: 'project-create-importer-upload-flow.upload-screen-standard.upload-config.upload-configuration-description',
		defaultMessage:
			'Adding a configuration file will bring in preferences selected in a previous import such as mapped fields and users. <link>Learn about using configuration files</link>',
		description: 'Upload configuration accordion description',
	},
	formatError: {
		id: 'project-create-importer-upload-flow.upload-screen-standard.upload-config.format-error',
		defaultMessage: 'The file format is incorrect. Upload another configuration file.',
		description: 'Configuration file format error',
	},
	disabledTooltip: {
		id: 'project-create-importer-upload-flow.upload-screen-standard.upload-config.disabled-tooltip',
		defaultMessage: 'You will need to first upload a CSV file.',
		description: 'Disabled upload button tooltip message',
	},
});
